import { api } from '../../axios.instance';

export const simulateSyncFailure = () =>
  api.post('/sync-alert-config/simulate-failure');
